import styled from "styled-components";
import { CSSProperties } from "react";

export function Logo({
  className,
  style,
}: {
  className: string;
  style?: CSSProperties;
}) {
  return (
    <Svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 865.52 192.55"
      className={className}
    >
      <defs />
      <g id="Réteg_2" data-name="Réteg 2">
        <g id="Layer_1" data-name="Layer 1">
          <path d="M169.28 126.06H147V58.47q-4.38 4.14-8.62 8.73t-8.86 9.43q.23 12.18-.11 24.6t-.41 24.83h-21.11V78.93a8.05 8.05 0 0 0-2-4.48 50.29 50.29 0 0 0-4.75-5.45c-1.86-1.84-3.78-3.68-5.72-5.52s-3.53-3.37-4.77-4.59v67.13H68.8V27.43h20.47l29.2 28.05 29.66-28h21.15ZM259.87 127.21h-70.59V28.35h70.59ZM238 105.37V50.19h-27.57v55.18ZM350.22 127.21h-70.58V28.35h70.58Zm-21.83-21.84V50.19h-27.6v55.18ZM441.05 126.06h-21.4V89l-29.89-30.3v67.36h-21.83V27.2h21.38q7.17 7.13 15.17 14.94t14.72 14.49V26.74h21.85ZM531.86 126.75H462v-21.84h47.6q-12.46-12.18-25.1-25.06t-23.45-24.14a53.26 53.26 0 0 1-.47-7.7v-5.64c0-.3 0-1 .11-2.18s.16-2.45.24-3.91.12-3 .12-4.48a36.56 36.56 0 0 0-.23-4.14h71V49.5h-46.4l46.44 46.44ZM622.44 126.75H600.6V86.52q-2.55.23-5.91.23h-20.76a.68.68 0 0 1-.45.23l-.47.46c-.16 6.44-.22 13-.22 19.77s.14 13 .45 18.85a1.67 1.67 0 0 1-.91.35 21.25 21.25 0 0 1-2.84.11H563q-4.31 0-11.83-.23V27.43h22.76l-.45.46a1.29 1.29 0 0 0-.47.92V47.2c0 3.22 0 6.37.11 9.43s.12 5.82.12 8.28q4.63.45 12.41.45t14.73-.45V27.43h22.06ZM712.35 127.21h-70.59V28.35h70.59Zm-21.85-21.84V50.19h-27.6v55.18ZM811 49.27h-29.91s.11 50.39.34 56.9.35 13.15.35 19.89a1.75 1.75 0 0 1-.92.35 22 22 0 0 1-2.88.11c-1.46 0-3.6 0-6.43-.11s-6.71-.19-11.62-.35c0 0-.08-71.81-.69-77h-28.73V27.43H811ZM31.71 155.26H0V3.65h31.71V13.9H12.6V145h19.11ZM865.52 151.6H833.9v-10.25h19V10.23h-19V0h31.62ZM241.45 171.12v3.23h-6.75v18.05h-3.59v-18.05h-6.71v-3.23ZM257.24 171.12v9.24h11.27v-9.24h3.59v21.28h-3.59v-8.82h-11.27v8.82h-3.59v-21.28ZM302 171.12v3.23h-11.58v5.77h10.4v3.19h-10.4v5.87h12v3.22h-15.58v-21.28ZM335.31 171.12l6.57 17.3 6.62-17.3h3.74l-8.6 21.28h-3.7l-8.48-21.28ZM367.86 171.12v21.28h-3.59v-21.28ZM396.07 192.4l-3.89-6.4h-6v6.41h-3.59v-21.29h8.63c5.44 0 8.57 2.65 8.57 7.27 0 3.4-1.58 5.8-4.41 6.9l4.78 7.11Zm-4.86-9.64c3.28 0 5.17-1.39 5.17-4.28s-1.89-4.13-5.17-4.13h-5v8.41ZM428.23 171.12v3.23h-6.75v18.05h-3.59v-18.05h-6.72v-3.23ZM449.3 189.33c3.47 0 5.62-2.13 5.62-5.75v-12.46h3.59v12.46c0 5.57-3.49 9-9.24 9s-9.27-3.4-9.27-9v-12.46h3.59v12.46c0 3.59 2.22 5.75 5.71 5.75ZM485.92 187.6h-10.73l-2 4.8h-3.74l9.4-21.28h3.67l9.3 21.28H488Zm-1.37-3.19-4-9.46-4 9.46ZM507.34 171.12v18h9.2v3.25h-12.79v-21.25ZM560.86 192.4 557 186h-6v6.41h-3.59v-21.29H556c5.44 0 8.58 2.65 8.58 7.27 0 3.4-1.58 5.8-4.41 6.9l4.77 7.11Zm-4.86-9.64c3.29 0 5.17-1.39 5.17-4.28s-1.88-4.13-5.17-4.13h-5v8.41ZM592.21 187.6h-10.72l-2 4.8h-3.74l9.39-21.28h3.68l9.3 21.28h-3.83Zm-1.37-3.19-4-9.46-4 9.46ZM619 174.22a7.5 7.5 0 1 0 0 15 8.81 8.81 0 0 0 5.93-2.52l2.12 2.37a12.07 12.07 0 0 1-8.23 3.49 10.79 10.79 0 0 1-11.07-10.82c0-6 4.9-10.7 11.19-10.7a11.71 11.71 0 0 1 8.08 3.29l-2.09 2.61a8.32 8.32 0 0 0-5.93-2.72ZM655 171.12v3.23h-11.59v5.77h10.4v3.19h-10.4v5.87h12v3.22h-15.59v-21.28Z" />
        </g>
      </g>
    </Svg>
  );
}

export function TextOnlyLogo({ className }: { className: string }) {
  return (
    <Svg2
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 741.91 162.5"
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            className="cls-1"
            d="M100.44,99.29H78.15V31.72c-2.92,2.75-5.79,5.67-8.62,8.73s-5.78,6.21-8.85,9.43q.23,12.17-.12,24.58t-.34,24.83H39.07V52.17a8.05,8.05,0,0,0-2-4.48,49.17,49.17,0,0,0-4.77-5.4c-1.86-1.84-3.77-3.68-5.71-5.52s-3.53-3.37-4.77-4.59V99.29H0V.69H20.45l29.19,28L79.3.69h21.14Z"
          />
          <path
            className="cls-1"
            d="M191,100.44H120.43V1.61H191ZM169.16,78.6V23.44H141.58V78.6Z"
          />
          <path
            className="cls-1"
            d="M281.31,100.44H210.76V1.61h70.55ZM259.49,78.6V23.44H231.9V78.6Z"
          />
          <path
            className="cls-1"
            d="M372.11,99.29H350.72v-37L320.85,32V99.29H299V.46h21.37q7.17,7.13,15.17,14.94t14.71,14.47V0h21.84Z"
          />
          <path
            className="cls-1"
            d="M462.89,100H393V78.14h47.58q-12.4-12.18-25-25T392.1,29a53.31,53.31,0,0,1-.46-7.7V15.63c0-.31,0-1,.11-2.19s.15-2.45.23-3.9.12-2.95.12-4.49a34.2,34.2,0,0,0-.23-4.13h71V22.75H416.46l46.43,46.43Z"
          />
          <path
            className="cls-1"
            d="M553.44,100H531.61V59.75c-1.71.16-3.67.24-5.91.24H505a.66.66,0,0,1-.46.22l-.47.47q-.22,9.65-.22,19.76t.46,18.85a1.85,1.85,0,0,1-.92.34,21.15,21.15,0,0,1-2.84.11H494q-4.31,0-11.82-.22V.69H505l-.46.46a1.29,1.29,0,0,0-.47.92V20.45c0,3.22,0,6.37.12,9.42s.12,5.83.12,8.28q4.64.47,12.4.46t14.72-.46V.69h22.06Z"
          />
          <path
            className="cls-1"
            d="M643.31,100.44H572.74V1.61h70.57ZM621.47,78.6V23.44H593.89V78.6Z"
          />
          <path
            className="cls-1"
            d="M741.91,22.52H712s.12,50.38.35,56.88.35,13.15.35,19.89a1.89,1.89,0,0,1-.92.34,22,22,0,0,1-2.88.11c-1.46,0-3.6,0-6.43-.11l-11.61-.34s-.08-71.79-.69-77H661.46V.69h80.45Z"
          />
          <path
            className="cls-1"
            d="M157.93,144.44c3.72,0,6,1.69,6,4.48a3.94,3.94,0,0,1-3.16,4,4.35,4.35,0,0,1,3.85,4.53c0,3.08-2.49,4.92-6.54,4.92h-8V144.44Zm-4.76,7.43h4.61c1.92,0,3.08-.9,3.08-2.41s-1.16-2.33-3.08-2.33h-4.61Zm0,7.81h4.61c2.36,0,3.77-.92,3.77-2.61s-1.41-2.54-3.77-2.54h-4.61Z"
          />
          <path
            className="cls-1"
            d="M178.94,147.15V152h8.76v2.71h-8.76v4.95H189v2.71H175.92V144.44h12.81v2.71Z"
          />
          <path
            className="cls-1"
            d="M207.76,162.37h-3V156.5l-6.69-12.06h3.05l5.13,8.73,5-8.73h3.07l-6.58,12Z"
          />
          <path
            className="cls-1"
            d="M241.16,153.4a9.51,9.51,0,0,1-19,0c0-5.15,4.15-9,9.51-9S241.16,148.28,241.16,153.4Zm-15.93,0a6.42,6.42,0,0,0,12.83,0,6.42,6.42,0,0,0-12.83,0Z"
          />
          <path
            className="cls-1"
            d="M264.65,162.37l-9.55-12.86v12.86h-3V144.44h3l9.61,12.88V144.44h3v17.93Z"
          />
          <path
            className="cls-1"
            d="M287.4,144.44c5.38,0,9.27,3.76,9.27,9s-3.92,9-9.35,9h-7.27V144.44Zm-4.33,15.22h4.41a6,6,0,0,0,6.14-6.23,6.12,6.12,0,0,0-6.27-6.28h-4.28Z"
          />
          <path
            className="cls-1"
            d="M328.44,147.15v15.22h-3V147.15h-5.66v-2.71h14.37v2.71Z"
          />
          <path
            className="cls-1"
            d="M356.92,162.37v-7.43h-9.5v7.43h-3V144.44h3v7.79h9.5v-7.79h3v17.93Z"
          />
          <path
            className="cls-1"
            d="M375.36,147.15V152h8.77v2.71h-8.77v4.95h10.1v2.71H372.34V144.44h12.81v2.71Z"
          />
          <path
            className="cls-1"
            d="M426,153.56v6.61a12.13,12.13,0,0,1-7,2.33,9.14,9.14,0,0,1-9.43-9.1c0-5.12,4.17-9,9.61-9a10.75,10.75,0,0,1,6.89,2.51l-1.72,2.23a7.78,7.78,0,0,0-5.17-2,6.37,6.37,0,1,0,0,12.73,8.39,8.39,0,0,0,4.13-1.23v-5Z"
          />
          <path
            className="cls-1"
            d="M446.09,156.94a7.22,7.22,0,0,1-.82,0H441v5.4h-3V144.44h7.27c4.59,0,7.23,2.23,7.23,6.12a5.78,5.78,0,0,1-3.72,5.82l4,6h-3.43Zm-.82-2.69c2.77,0,4.36-1.18,4.36-3.61s-1.59-3.49-4.36-3.49H441v7.1Z"
          />
          <path
            className="cls-1"
            d="M481.72,153.4a9.51,9.51,0,0,1-19,0c0-5.15,4.15-9,9.51-9S481.72,148.28,481.72,153.4Zm-15.93,0a6.43,6.43,0,0,0,6.46,6.38,6.35,6.35,0,1,0-6.46-6.38Z"
          />
          <path
            className="cls-1"
            d="M507.88,154.94c0,4.69-2.95,7.56-7.79,7.56s-7.81-2.87-7.81-7.56v-10.5h3v10.5a4.48,4.48,0,0,0,4.82,4.84c2.92,0,4.73-1.79,4.73-4.84v-10.5h3Z"
          />
          <path
            className="cls-1"
            d="M532.47,162.37l-9.56-12.86v12.86h-3V144.44h3l9.61,12.88V144.44h3v17.93Z"
          />
          <path
            className="cls-1"
            d="M555.22,144.44c5.38,0,9.27,3.76,9.27,9s-3.92,9-9.35,9h-7.28V144.44Zm-4.33,15.22h4.4a6,6,0,0,0,6.15-6.23,6.12,6.12,0,0,0-6.27-6.28h-4.28Z"
          />
        </g>
      </g>
    </Svg2>
  );
}

const Svg2 = styled.svg`
  color: white;
  .cls-1 {
    fill: #231f20;
  }
  path {
    fill: currentColor !important;
  }
`;

const Svg = styled.svg`
  transition: opacity 0.3s;
  path {
    fill: currentColor;
  }
`;
